import {makeEnterpriseComponent} from "../../util/utility";


class UniqueValidator {
    constructor() {
        this.picklistEC = null;
        this.listener = null;
        this.field = null;
        this.formElementId = null;
    }

    enterpriseComponentLoadCompleted = (ec) => {
        this.listener.validatorFetchCompleted(this.formElementId, ec);
    };

    validate = (detail, value, value2, field, formElementId, attribute) => {
        let picklist = attribute.getPicklist();

        if (picklist !== null && picklist.getStatic() === false) {
            this.field = field;
            this.listener = detail;
            this.formElementId = formElementId;
            this.picklistEC = makeEnterpriseComponent(picklist.getEnterpriseComponent());

            let searchSpec = picklist.getSearchSpecification()
            if (searchSpec === null) {
                searchSpec = {}
            }
            searchSpec[picklist.getTypeValue()] = value;

            if (value2 !== null) {
                searchSpec[picklist.getTypeValue2()] = value2;
            }

            this.listener.validatorFetchInitiated(this.formElementId, value);
            this.picklistEC.addLoadCompletedListener(this);
            this.picklistEC.newQuery();
            this.picklistEC.setSearchSpecification(searchSpec);
            let keys = Object.keys(searchSpec);
            for (let key of keys) {
                this.picklistEC.setAttributeValue(key, searchSpec[key]);
            }

            this.picklistEC.executeQuery();
        }
    };
}

export default UniqueValidator;